interface ReportExportPanelProps {
  onDownloadPdf: () => void;
  disabled?: boolean;
}

export function ReportExportPanel({
  onDownloadPdf,
  disabled = false,
}: ReportExportPanelProps): JSX.Element {
  return (
    <button
      type="button"
      onClick={onDownloadPdf}
      disabled={disabled}
      className="inline-flex min-h-11 items-center justify-center rounded-xl bg-accent-warm px-4 py-2 text-sm font-semibold text-white shadow-[0_12px_24px_-16px_rgba(196,82,24,0.9)] transition-colors duration-150 hover:bg-accent-warm-dark focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent-warm focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:bg-slate-200 disabled:text-slate-400 disabled:shadow-none"
    >
      导出 PDF
    </button>
  );
}
